import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/account/login";
import { AccountRoute } from "./component/account-route";


const AuthRoutes = (props) => {
    return (

        <Routes>

            <Route element={<AccountRoute />}>
                <Route path="/" element={<Login />}></Route>
                <Route index element={<Login />} />
                <Route path="login" element={<Login />} />
            </Route>

        </Routes>

    );
};

export default AuthRoutes;
